import { useDesignMaxTheme } from "@/packages";
import { FONT, RADIUS } from "@/styles";
import { Box, Center, Grid } from "@chakra-ui/react";
import dayjs from "dayjs";
import { generatedValidDates } from "../../utils";
import { type CurrentDateProps } from "./currentDates.type";

export const CurrentDates = ({ calendar, title, ...rest }: CurrentDateProps) => {
    const { checkIn, checkOut, onChangeColor, maxDate, onNavigate } = rest;
    const { newCalendarDates } = generatedValidDates({ calendar, checkIn, checkOut, title });
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    return (
        <Grid gridTemplateColumns="repeat(7, 1fr)" rowGap="8px">
            {newCalendarDates?.map((calendar, index) => {
                const keyProp = index;
                const { date, comparisonDate, getTimeComparisonDate, ...rest } = calendar;
                const { isBetween, isCheckIn, isCheckOut, isCurrentDateValid } = rest;
                const isMaxValid = maxDate && maxDate.valueOf() < getTimeComparisonDate;
                const weekDayNum = dayjs(comparisonDate).day();

                return (
                    <Box
                        w={isMobile ? "36px" : "48px"}
                        h={isMobile ? "36px" : "48px"}
                        position="relative"
                        boxSizing="border-box"
                        cursor="pointer"
                        key={keyProp}
                        onClick={() => !isCurrentDateValid && onChangeColor(comparisonDate, onNavigate)}
                        className={isCurrentDateValid ? "low_than_today" : ""}
                        sx={{
                            "&::before": {
                                content: '""',
                                w: isCheckIn || isCheckOut ? "50%" : "0",
                                h: "100%",
                                position: "absolute",
                                top: 0,
                                left: isCheckIn ? "50%" : "0",
                                bgColor: COLORS.beige,
                                zIndex: 1,
                            },
                        }}
                    >
                        <Center
                            position="absolute"
                            w="100%"
                            h="100%"
                            zIndex="2"
                            color={COLORS.gray[300]}
                            sx={{
                                ...(isBetween ? { ...RADIUS(0) } : { ...RADIUS(50) }),
                                ...FONT("pretendard", 14, 500),
                                color: () => {
                                    if (isCheckIn || isCheckOut) return COLORS.white;
                                    if (isMaxValid) return COLORS.gray[300];
                                    if (weekDayNum === 0) return COLORS.pink;
                                    if (weekDayNum === 6) return COLORS.blue[300];

                                    return COLORS.black;
                                },
                                bgColor: () => {
                                    if (isCheckIn) return COLORS.pink;
                                    if (isCheckOut) return COLORS.pink;
                                    if (isBetween) return COLORS.beige;

                                    return COLORS.white;
                                },
                                "&::hover": {
                                    border: `1px solid ${COLORS.pink}`,
                                    ...RADIUS(50),
                                },
                            }}
                        >
                            {date}
                        </Center>
                    </Box>
                );
            })}
        </Grid>
    );
};
